import phone from 'assets/images/phone.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { phoneNumberConfirm, phoneNumberReject } from '../../registration/actions';
import { getPhoneNumber } from '../../registration/selectors';

export const ConfirmPhoneNumber = ({ phoneNumber, confirm, reject }) => (
  <div className="modal confirm-phone">
    <img src={phone} className="confirm-phone__image" />
    <h2 className="confirm-phone__header">Confirm Mobile Number</h2>
    <h1 className="confirm-phone__number">
      {phoneNumber}
    </h1>
    <p className="confirm-phone__text">
      Confirm that the above mobile number is correct.
    </p>
    <div className="modal__button-line">
      <Button
        className="modal__button button--secondary"
        onClick={reject}
      >
        Cancel
      </Button>
      <Button
        className="modal__button"
        onClick={confirm}
      >
        Continue
      </Button>
    </div>
  </div>
);

ConfirmPhoneNumber.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  phoneNumber: getPhoneNumber(state)
});

const mapDispatchToProps = {
  confirm: phoneNumberConfirm,
  reject: phoneNumberReject
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPhoneNumber);
